export default __webpack_public_path__ + "static/media/header.01a97f94.png";